import { InjectionToken } from '@angular/core';

export interface ModuleOptionsModel {
  useBearer?: boolean;
  clientHeaderName?: string;
  skipClientSelection?: boolean;
}

// for AoT
export let FOR_ROOT_OPTIONS_TOKEN = new InjectionToken<ModuleOptionsModel>('forRoot() ConfigurationService');
